exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cookie-popup {\n    position: fixed;\n    bottom: 20px;\n    left: 20px;\n    right: 20px;\n    background: #222;\n    color: white;\n    padding: 15px;\n    text-align: center;\n    border-radius: 5px;\n    -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n            box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n    font-size: 2rem;\n    z-index: 1001;\n}\n\n.cookie-popup a {\n    color: #d50b01bb;\n\n\n}\n\n.cookie-popup a:hover {\n    color: #d50b01;\n}\n\n.cookie-popup button {\n    background: #d50b01bb;\n    /* #4caf50; */\n    color: #ddd;\n    border: none;\n    padding: 10px 20px;\n    cursor: pointer;\n    margin-left: 10px;\n    border-radius: 5px;\n}\n\n.cookie-popup button:hover {\n    background: #d50b01;\n    color: #fff;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/shared/widgets/cookie-consent/cookie-consent.component.css
// module id = ../../../../../src/app/shared/widgets/cookie-consent/cookie-consent.component.css
// module chunks = main